import { QuestionnaireContext } from 'components/Assessment/QuestionnaireContext'
import { useContext, useState } from 'react'
import { AssessmentContainer, PageContent } from '../styles'
import Footer from '../layout/Footer'
import Header from '../layout/Header'
import MainContentSection from './MainContentSection'
import QuestionSelectorModal from 'components/TableOfContentModals/QuestionSelectorModal'
import ClearModal from 'components/Assessment/models/ClearModal'
import FinishModal from 'components/Assessment/models/FinishModal'
import PauseExitModal from 'components/Assessment/models/PauseExitModal'
import AnswerSubmittingModal from 'components/Assessment/models/answerSubmittingModal'
import UnAvailableTestModal from 'components/Assessment/models/UnAvailableTest'
import AssesmentScoreModal from 'common/Modals/AssesmentScoreModal'
import Cookies from 'js-cookie'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { ViewMode } from 'interfaces/app'
import { useDispatch } from 'react-redux'
import { setAssessments } from 'app/reducer/assessmentSlice'

const AssessmentContainerLayout = () => {
  const [activeTab, setActiveTab] = useState<'tab1' | 'tab2'>('tab1')
  const [questionVisible, setQuestionVisible] = useState(true)
  const [showQuestionSelectorModal, setShowQuestionSelectorModal] =
    useState(false)
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const {
    setShowClearModal,
    questionIdx,
    setShowPauseExitModal,
    onChangeQuestionFromTopBar,
    currentQuestion,
    hasPreviousQuestion,
    previousQuestion,
    nextQuestion,
    hasNextQuestion,
    questions,
    setShowFinishModal,
    onExit,
    viewMode
  } = useContext(QuestionnaireContext)

  /**
   * Benchmark review reuses the existing student mode query flag, while the
   * standard assessment launch omits it and should stay interactive.
   */
  const isReadOnlyViewMode =
    searchParams.get('viewMode') === String(ViewMode.Student) &&
    viewMode === ViewMode.Student

  const onClearPress = () => {
    setShowClearModal(true)
  }

  const onPauseExitPress = () => {
    setShowPauseExitModal(true)
  }

  const onExitPress = async () => {
    /**
     * Read only benchmark review skips the pause flow and reuses the existing
     * exit cleanup before taking the student back to the classroom.
     */
    await onExit()
    dispatch(setAssessments([]))
    navigate('/classroom')
  }

  const onFinishPress = () => {
    setShowFinishModal(true)
  }

  const onNextPress = () => {
    nextQuestion()
  }

  const onBackQuestionPress = () => {
    previousQuestion()
  }

  const assessmentName = Cookies.get('assessmentName') || ''

  return (
    <AssessmentContainer>
      <PageContent>
        <Header
          assessmentName={assessmentName}
          onQuestionSelector={() => setShowQuestionSelectorModal(true)}
        />

        <MainContentSection
          activeTab={activeTab}
          questionVisible={questionVisible}
          setActiveTab={setActiveTab}
          setQuestionVisible={setQuestionVisible}
        />

        <Footer
          type='assessments'
          onClear={onClearPress}
          onNext={onNextPress}
          onPauseExit={isReadOnlyViewMode ? onExitPress : onPauseExitPress}
          onBack={onBackQuestionPress}
          onFinish={onFinishPress}
          disableFinish={hasNextQuestion}
          disableClear={currentQuestion.answer === null}
          disableNext={!hasNextQuestion}
          disableBack={!hasPreviousQuestion}
          readOnly={isReadOnlyViewMode}
        />

        <ClearModal />
        <PauseExitModal />
        <AnswerSubmittingModal />
        <UnAvailableTestModal />
        <AssesmentScoreModal />
        <FinishModal />

        <QuestionSelectorModal
          showQuestionSelectorModal={showQuestionSelectorModal}
          setShowQuestionSelectorModal={setShowQuestionSelectorModal}
          assessmentName={assessmentName}
          questions={questions}
          currentQuestionIndex={questionIdx}
          isReadOnlyViewMode={isReadOnlyViewMode}
          onSelectQuestion={(questionIndex: any) => {
            onChangeQuestionFromTopBar(questionIndex)
          }}
        />
      </PageContent>
    </AssessmentContainer>
  )
}

export default AssessmentContainerLayout
